import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#8D4E3C',      // Terracota principal
        secondary: '#6D4C41',    // Marrón oscuro
        accent: '#90A4AE',       // Gris azulado
        error: '#D32F2F',        // Rojo para errores
        info: '#8D6E63',         // Marrón grisáceo para info
        success: '#388E3C',      // Verde para éxito
        warning: '#F57C00',      // Naranja para advertencias
        surface: '#FAFAFA',      // Superficie clara
        background: '#F5F5F5'    // Fondo gris muy claro
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  }
})